module.exports = __webpack_public_path__ + "img/2.4c75f8c2.png";